export default {
  返回顶部: 'To top',
  开拓市场寻觅商机: 'Expand Markets & Find Opportunities',
  进入领券: 'Get coupons',
  企业员工列表: 'Corporate Staff List',
  立即洽谈: 'Chat',
  '确定发送此图片吗?': 'Are you sure to send this image?',
  采购金额: 'Purchase amount',
  邀约客户: 'Invite customers',
  优惠券总额: 'Total Coupons',
  观展人次: 'Attendance',
  招标总额: 'Total Tender',
  直播视频: 'Live Video',
  暂无观看: 'No watch',
  获取Ta的名片: 'Exchange Business Cards',
  企业实景3D: 'Reality 3D',
  展览3D: 'Exhibition 3D',
}
